import { useGetDatasource } from "hooks/useMasterData";
import styled from "@emotion/styled";
import {
  Alert,
  Col,
  DatePicker,
  Divider,
  Form,
  Row,
  Select,
  Space,
} from "antd";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import dayjs from "dayjs";
import { RangePickerProps } from "antd/es/date-picker";
import { formatDates } from "utils/dateFormat";

const { Option } = Select;
interface MainOrderDatasourceProps {
  dueDate: Date | null;
  setDueDate: Dispatch<SetStateAction<Date | null>>;
}

const MainCreateOrderDuedate: FC<MainOrderDatasourceProps> = ({
  dueDate,
  setDueDate,
}) => {
  // const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  //   return current && current < dayjs().add(0, 'day').endOf('day');
  // };
  const [lateDay, setLateDay] = useState<boolean>(false);
  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return current && current < dayjs().startOf("day");
  };

  useEffect(() => {
    const now = dayjs();
    const defaultDate = now.hour() < 10 ? now : now.add(1, "day");
    if (now.hour() >= 10) setLateDay(true);
    else setLateDay(false);

    setDueDate(defaultDate.toDate());
  }, [setDueDate]);

  return (
    <>
      <FormWrapper>
        <Row style={{ backgroundColor: "#EFEFEFEF" }}>
          <Col span={24}>
            <FormWrapper>
              <FormItems
                label="วันที่ต้องส่งสินค้า"
                name="due_date"
                style={{ fontWeight: "400", marginLeft: "5px" }}>
                <Space direction="horizontal">
                  <DatePicker
                    disabledDate={disabledDate}
                    style={{ width: "200px" }}
                    format="YYYY-MM-DD"
                    placeholder="ระบุวันที่ต้องส่งสินค้า"
                    value={dueDate ? dayjs(dueDate) : null}
                    // ตรวจสอบ dateString ถ้าเป็น array ให้ใช้ตัวแรก เพื่อป้องกัน TS2769
                    onChange={(date, dateString) =>
                      setDueDate(
                        date
                          ? new Date(
                              Array.isArray(dateString)
                                ? dateString[0]
                                : dateString
                            )
                          : null
                      )
                    }
                  />
                </Space>
              </FormItems>
              {lateDay && (
                <Alert
                  showIcon
                  style={{ margin: "5px", padding: "5px", width: "500px" }}
                  message="ปัจจุบันเวลาเกิน 10.00 น"
                  description={`ค่าเริ่มต้นของ "วันที่ต้องส่งสินค้า" จะถูกปรับเป็นวันที่ ${dayjs()
                    .add(1, "day")
                    .format("YYYY-MM-DD")
                    .toString()}`}
                  type="warning"
                />
              )}
            </FormWrapper>
          </Col>
        </Row>
      </FormWrapper>
    </>
  );
};

export default MainCreateOrderDuedate;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width: 300px;
`;
const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10x;
  background-color: #ffffffff;
`;
